import { render, staticRenderFns } from "./PosicaoAmostras.vue?vue&type=template&id=0d0a78f6&"
import script from "./PosicaoAmostras.vue?vue&type=script&lang=js&"
export * from "./PosicaoAmostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports